export default __webpack_public_path__ + "static/media/ky.41e3ee69.png";